export enum FokParameterType {
  AvtalspensionSAFLOAfter65 = 'TILLVAL_ASL65+',
  KPAfter65 = 'TILLVAL_KP65+',
}

export const fokParameterTypeFromString = (fokParameterType: string): FokParameterType => {
  switch (fokParameterType) {
    case 'TILLVAL_ASL65+':
      return FokParameterType.AvtalspensionSAFLOAfter65;
    case 'TILLVAL_KP65+':
      return FokParameterType.KPAfter65;
    default:
      return FokParameterType.AvtalspensionSAFLOAfter65;
  }
};
